module.exports = {
	"pageTitle": "About",
	"link": "about",
	"aboutPageText": "About Claire Messud",
	"description": "<p><strong>Claire Messud</strong>&nbsp;is the author of six works of fiction. A recipient of a Guggenheim and Radcliffe Fellowships and the Strauss Living Award from the American Academy of Arts and Letters, she lives in Cambridge, Massachusetts, with her family.</p>\n",
	"showNewsletter": true,
	"authorImageURL": "http://cdn.wwnorton.com/marketing/trade/messud/messud480x480.png",
	"title": "About"
};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/about.json
// module id = 503
// module chunks = 0